import { CategoryState } from 'store/category/types';

const resetCategoriesReducer = (state: CategoryState) => {
  state.categories = undefined;
  state.totalFamiliesFetched = 0;
  state.familiesOffset = 99999;
  state.totalFamiliesAvailable = 0;
};

export default resetCategoriesReducer;
